import { render, staticRenderFns } from "./NavMenuGroup.vue?vue&type=template&id=dbcfdb32"
import script from "./NavMenuGroup.vue?vue&type=script&lang=js"
export * from "./NavMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./NavMenuGroup.vue?vue&type=style&index=0&id=dbcfdb32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports